import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EPSL_AUDITS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('EPSL_AUDITS');
export const EPSL_AUDITS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EPSL_AUDITS_CRUD_ACTION_CONSTANTS
);
